import gettext from "../../shared/utils/gettext";
import cropr from "../../shared/utils/cropr";
import { FinancialData, PageData, PageDataData, useFinancialDataProps } from "./useFinancialData";

export function getFinancialTotals(data?: FinancialData) {
  let costs = 0,
    revenues = 0;
  if (data) {
    for (let p of data.pages) {
      if (p.data && p.data.length > 0 && p.data[0].code === "Total") {
        costs += p.data[0].data.rows[0][6];
        revenues += p.data[0].data.rows[1][6];
      }
    }
  }
  return [costs, revenues];
}

export const aggregateNames = [gettext("Crop"), gettext("Field"), gettext("Variety")];
export const aggregates = ["crop", "", "variety"];
export function getUrl({ aggregate, cropFieldId }: useFinancialDataProps) {
  return cropFieldId
    ? `/cropr/export/balance_xls/${cropFieldId}`
    : `/cropr/export/balance_plan_xls/${cropr.mainplan.id}/${aggregates[aggregate || 0]}`;
}

export function formatNumber(e: any, isCurrency: boolean, isArea = false, precision = 2) {
  if (typeof e !== "number") return e;
  if (!e) return "-";
  if (isArea) {
    return cropr.toLocaleFixed(e, precision, true) + " " + cropr.l10n.unit_area_display;
  }
  return (
    (isCurrency ? cropr.l10n.unit_currency_sign + "\u00A0" : "") +
    cropr.toLocaleFixed(e, precision, true)
  );
}

// Divide Summary Page per ha (second element in PageDataData row). Dynamic typing is complex
export const dividePageDataPerHa = ({ header, name, rows }: PageDataData): PageDataData => ({
  header,
  name,
  // @ts-ignore
  rows: rows.map((r) =>
    // @ts-ignore
    r.map((e, i) => (i < 4 ? e : e / (r[3] || 1)))
  ),
});

export const dividePerHa = ({ name, data }: PageData): PageData => ({
  name,
  data: data.map(({ code, data }) => ({
    code,
    data: dividePageDataPerHa(data),
  })),
});
